export const convertFabricCanvasToPNGDataURL = (canvasJSON) => {
  return new Promise((resolve, reject) => {
    if (!canvasJSON) return reject("No canvas data");
    const offscreenCanvas = document.createElement("canvas");
    offscreenCanvas.width = 1000;
    offscreenCanvas.height = 1000;
    const staticCanvas = new fabric.StaticCanvas(offscreenCanvas, {
      width: 1000,
      height: 1000,
    });

    staticCanvas.loadFromJSON(canvasJSON, () => {
      const objects = staticCanvas.getObjects();
      if (!objects.length) return reject("No objects in canvas");
      let left = Infinity;
      let top = Infinity;
      let right = -Infinity;
      let bottom = -Infinity;
      objects.forEach((obj) => {
        const coords = obj.getCoords();
        coords.forEach((point) => {
          left = Math.min(left, point.x);
          top = Math.min(top, point.y);
          right = Math.max(right, point.x);
          bottom = Math.max(bottom, point.y);
        });
      });

      const margin = 5;
      left -= margin;
      top -= margin;
      right += margin;
      bottom += margin;
      const width = right - left;
      const height = bottom - top;

      const originalBackgroundColor = staticCanvas.backgroundColor;
      staticCanvas.backgroundColor = "transparent";
      const pngDataURL = staticCanvas.toDataURL({
        format: "png",
        multiplier: 2,
        left,
        top,
        width,
        height,
        transparent: true,
      });
      staticCanvas.backgroundColor = originalBackgroundColor;

      resolve(pngDataURL);
    });
  });
};

export const handleDownloadSVG = (canvas) => {
  if (!canvas) return;

  const originalBackgroundColor = canvas.backgroundColor;
  canvas.backgroundColor = null;

  const svgDataURL = canvas.toSVG();

  canvas.backgroundColor = originalBackgroundColor;

  const svgBlob = new Blob([svgDataURL], { type: "image/svg+xml" });

  const svgURL = URL.createObjectURL(svgBlob);

  return svgURL;
};

/**
 * Converts an SVG URL to a PNG data URL using an offscreen canvas.
 * @param {string} svgUrl - The URL of the SVG image.
 * @returns {Promise<string>} - A promise that resolves with the PNG data URL.
 */
export const convertSVGToPNGDataURL = (svgUrl) => {
  return new Promise((resolve, reject) => {
    if (!svgUrl) return reject("No SVG URL provided");

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      // Determine screen width
      const screenWidth =
        window.innerWidth || document.documentElement.clientWidth;
      const canvasSize = 500;

      const canvas = document.createElement("canvas");
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const ctx = canvas.getContext("2d");
      // Disable image smoothing for crisp pixels
      ctx.imageSmoothingEnabled = false;

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const pngDataURL = canvas.toDataURL("image/png");
      resolve(pngDataURL);
    };
    img.onerror = (err) => reject(err);
    img.src = svgUrl;
  });
};

export const handleDownload = async (
  downloadName,
  fabricCanvas,
  canvasesState,
  afterDownloadCallback
) => {
  let url = "";
  const name = downloadName === "editSVG" ? "canvas.svg" : "canvas.png";

  const savedState = canvasesState[`${downloadName}CanvasState`]?.currentState;

  if (!savedState) {
    if (!fabricCanvas) {
      return;
    }
    console.warn(
      `No saved state for "${downloadName}" found. Using the current canvas instead.`
    );
    url =
      downloadName === "editSVG"
        ? handleDownloadSVG(fabricCanvas)
        : fabricCanvas?.lowerCanvasEl?.toDataURL("image/png");
  } else {
    // Create a new static canvas and load from the saved state
    const staticCanvas = new fabric.StaticCanvas("c");
    url = await new Promise((resolve, reject) => {
      staticCanvas.loadFromJSON(savedState, () => {
        try {
          const availableWidth = window.innerWidth - 700;
          const availableHeight = window.innerHeight - 150;
          const baseWidth = 650;
          const baseHeight = 500;
          const scaleX = availableWidth / baseWidth;
          const scaleY = availableHeight / baseHeight;
          const scale = Math.min(scaleX, scaleY);

          staticCanvas.setDimensions({
            width: baseWidth * scale,
            height: baseHeight * scale,
          });
          staticCanvas.setZoom(1);
          staticCanvas.renderAll();

          const imageToDownload =
            downloadName === "editSVG"
              ? handleDownloadSVG(staticCanvas)
              : staticCanvas.toDataURL({
                  format: "png",
                  quality: 1,
                });
          resolve(imageToDownload);
        } catch (err) {
          reject(err);
        }
      });
    });
  }

  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  afterDownloadCallback && afterDownloadCallback();
};


